import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Flex, Modal, Typo, Carousel } from '../../ui';
import { SwiperSlide } from 'swiper/react';
import { useHasRequiredLevel } from '../auth/hooks';
import editorImg1 from './assets/feature-new-editor1.png';
import editorImg2 from './assets/feature-new-editor2.png';
import PageControls from '../../ui/Page/PageControls';

const ImageWrapper = styled.div`
  margin: 0;
  max-width: 600px;

  img {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    object-fit: contain;
  }
`;
const TextWrapper = styled.div`
  padding-bottom: 20px;
`;

const NewFeatures = ({ enabled }) => {
  const [hideMessage, setHideMessage] = useState(false);
  const isTeacher = useHasRequiredLevel('teacher');
  const isEditor = useHasRequiredLevel('editor');
  const show = (isTeacher || isEditor) && enabled;

  //change value so it is unique every time we show a new feature
  const currentProperty = 'newCourseEditor';

  useEffect(() => {
    const dontShowNewFeature = JSON.parse(localStorage.getItem('dontShowNewFeature'));
    setHideMessage(dontShowNewFeature && dontShowNewFeature[currentProperty]);
  }, [setHideMessage]);

  const onCloseModal = () => {
    setHideMessage(true);
  };

  const onSkipIt = () => {
    localStorage.setItem('dontShowNewFeature', JSON.stringify({ [currentProperty]: true }));
    onCloseModal();
  };

  const CardInfo = ({ imageSrc, title, text, alt }) => {
    return (
      <Flex maxWidth='600px' direction='column' gap='20' align='flex-start'>
        <ImageWrapper>
          <img alt={alt} src={imageSrc} loading='lazy' />
        </ImageWrapper>
        {title && (
          <TextWrapper>
            <Typo.TextTitle>{title}</Typo.TextTitle>
            <Typo.MediumText dangerouslySetInnerHTML={{ __html: text }}></Typo.MediumText>
          </TextWrapper>
        )}
      </Flex>
    );
  };

  return (
    <Modal
      open={!hideMessage && show}
      // onClose={onCloseModal}
      noBottomMargin={true}
      maxWidth='685px'
    >
      <Carousel navigation={false}>
        <SwiperSlide key={1}>
          {CardInfo({
            imageSrc: editorImg1,
            alt: 'new course editor',
            title: 'Introducing the New Course Editor',
            text: 'We have redesigned the course editor to make it easier and faster to create and manage your courses. The new editor is now the default experience for all users.',
          })}
        </SwiperSlide>
        <SwiperSlide key={2}>
          {CardInfo({
            imageSrc: editorImg2,
            alt: 'switch back to old editor',
            title: 'Prefer the old editor?',
            text: 'You can switch back to the previous editor at any time. Go to your <b>Profile</b> → <b>Beta Features</b> and toggle off the <b>Modern Course Builder</b> option.',
          })}
        </SwiperSlide>
      </Carousel>
      <PageControls
        openModelButton={
          <Flex gap='10'>
            <Button onClick={onCloseModal}>Remind me later</Button>
            <Button onClick={onSkipIt}>Skip it</Button>
          </Flex>
        }
      />
    </Modal>
  );
};

export default NewFeatures;
